import { DateTime } from 'luxon';
import { MochiCard } from '../mochi-card';
import classnames from 'classnames';
import { COUPON_ITEM_CLASS_NAME } from '../../constants';
import { CouponFillIcon } from "../icons";
import styles from './expired-coupon-item.module.sass';

export const ExpiredCouponItem = ({ coupon }) => {
  const { name, expiresAt, usedAt } = coupon;

  return (
    <MochiCard className={classnames(styles.root, COUPON_ITEM_CLASS_NAME)}>
        <div className={styles.header}>
        <div className={styles.left}>
          <CouponFillIcon color="#999999" width={28} height={28} />
        </div>
        <div className={styles.content}>
          <span className={styles.name}>{name}</span>
          <div className={styles.meta}>
            <span className={styles.time}>
              {formatTime(usedAt ?? expiresAt)}
            </span>
          </div>
        </div>
      </div>
    </MochiCard>
  );
};

function formatTime(iso: string) {
  return DateTime.fromISO(iso).toFormat('yyyy.MM.dd HH:mm');
}
